import { useEffect, useState } from "react";
import { motion } from "framer-motion";

// Cinematic launch overlay shown when project hits 100% (first time).
export default function LaunchOverlay({ logoUrl, finalUrl, onClose }) {
  const [phase, setPhase] = useState(0);
  useEffect(() => {
    const a = setTimeout(() => setPhase(1), 400);
    const b = setTimeout(() => setPhase(2), 1800);
    const c = setTimeout(() => setPhase(3), 3000);
    return () => {
      clearTimeout(a);
      clearTimeout(b);
      clearTimeout(c);
    };
  }, []);

  return (
    <motion.div
      className="fixed inset-0 z-[80] flex flex-col items-center justify-center bg-black/95 backdrop-blur-xl px-6"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      data-testid="launch-overlay"
    >
      {/* digital dust */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        {Array.from({ length: 40 }).map((_, i) => (
          <motion.span
            key={i}
            className="absolute h-1 w-1 rounded-full bg-white/60"
            initial={{ x: "50vw", y: "50vh", opacity: 0 }}
            animate={{
              x: `${Math.random() * 100}vw`,
              y: `${Math.random() * 100}vh`,
              opacity: [0, 0.8, 0],
            }}
            transition={{ duration: 2.5 + Math.random() * 2, delay: Math.random() * 1.5, repeat: Infinity }}
          />
        ))}
      </div>

      <motion.div
        initial={{ scale: 0.85, opacity: 0 }}
        animate={{ scale: phase >= 1 ? 1 : 0.85, opacity: phase >= 1 ? 1 : 0 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        className="relative"
      >
        <div className="absolute -inset-10 rounded-full bg-blue-500/10 blur-3xl" />
        <img src={logoUrl} alt="Repositor Online" className="relative w-72 sm:w-96 rounded-xl" />
      </motion.div>

      {phase >= 2 && (
        <motion.div
          className="mt-10 text-center"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="font-display text-4xl sm:text-6xl font-light tracking-tighter metallic-text">
            REPOSITOR ONLINE
          </h1>
          <p className="mt-4 max-w-lg mx-auto text-white/60">
            O futuro da conexão entre empresas e profissionais começa agora.
          </p>
          <div className="mt-6 flex items-center justify-center gap-6 font-mono text-xs text-white/40">
            <span>100% REVELADO</span>
            <span>·</span>
            <span>45 DIAS</span>
            <span>·</span>
            <span>45 ETAPAS</span>
            <span>·</span>
            <span>1 NOVA PLATAFORMA</span>
          </div>
        </motion.div>
      )}

      {phase >= 3 && (
        <motion.div
          className="mt-10 flex flex-col sm:flex-row gap-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <a
            href={finalUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="launch-enter-btn"
            className="rounded-full bg-white px-8 py-3 text-sm font-medium text-black transition-transform hover:scale-[1.03]"
          >
            CONHECER O REPOSITOR ONLINE
          </a>
          <button
            onClick={onClose}
            data-testid="launch-close-btn"
            className="rounded-full border border-white/15 px-8 py-3 text-sm text-white/70 transition-colors hover:text-white hover:border-white/30"
          >
            Ver a página
          </button>
        </motion.div>
      )}
    </motion.div>
  );
}
